import type { IKeywordsReportRecordsRawData } from "app/pages/digital-marketing/keywords-campaigns/reports/keywords-report/keywords-table/KeywordsReportTypes";
import type { DatesRange } from "app/pages/digital-marketing/keywords-campaigns/shared/types";

import { isKeywordsReportLatestAvailableDay } from "./isKeywordsReportLatestAvailableDay";

export const hasPendingKeywordRows = (
    records: IKeywordsReportRecordsRawData[] | undefined,
    durationObject: DatesRange | undefined,
    lastScrapeDate: string | null,
): boolean => {
    if (!isKeywordsReportLatestAvailableDay(durationObject, lastScrapeDate)) {
        return false;
    }
    return records?.some((record) => !record.lastUpdated) ?? false;
};
